export { default as Img200 } from './processed/200/Mr-Mercedes-S2.jpg';
export { default as Img400 } from './processed/400/Mr-Mercedes-S2.jpg';
export { default as Imgthumb } from './processed/thumb/Mr-Mercedes-S2.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Mr-Mercedes-S2.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Mr-Mercedes-S2.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      226,
      208,
      17
    ],
    "_population": 1963,
    "_hsl": [
      0.15231259968102073,
      0.8600823045267489,
      0.4764705882352941
    ]
  },
  "LightVibrant": {
    "_rgb": [
      228,
      228,
      140
    ],
    "_population": 1,
    "_hsl": [
      0.16666666666666666,
      0.6197183098591549,
      0.7215686274509805
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      108,
      92,
      12
    ],
    "_population": 2,
    "_hsl": [
      0.1388888888888889,
      0.8,
      0.23529411764705882
    ]
  },
  "Muted": {
    "_rgb": [
      186,
      180,
      99
    ],
    "_population": 88,
    "_hsl": [
      0.15517241379310348,
      0.3866666666666666,
      0.5588235294117647
    ]
  },
  "LightMuted": {
    "_rgb": [
      181,
      181,
      181
    ],
    "_population": 3015,
    "_hsl": [
      0,
      0,
      0.7098039215686275
    ]
  },
  "DarkMuted": {
    "_rgb": [
      75,
      75,
      74
    ],
    "_population": 3468,
    "_hsl": [
      0.16666666666666666,
      0.00671140939597313,
      0.29215686274509806
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Mr-Mercedes-S2.js